import { StaticLandingRoutes } from '@webapp/common/resources/landing-routes';

export const headerOpportunitiesOptions = [
    {
        label: `<a href='/ru/${StaticLandingRoutes.capabilitiesHr.path}'>Опросы для HR</a>`,
        value: 1,
        isHtml: true,
    },
    {
        label: `<a href='/ru/${StaticLandingRoutes.capabilitiesMarketing.path}'>Опросы для маркетинга</a>`,
        value: 2,
        isHtml: true,
    },
    {
        label: `<a href='/ru/${StaticLandingRoutes.capabilitiesTests.path}'>Тесты</a>`,
        value: 3,
        isHtml: true,
    },
    {
        label: `<a href='/ru/${StaticLandingRoutes.capabilitiesVotes.path}'>Голосования</a>`,
        value: 4,
        isHtml: true,
    },
    {
        label: `<a href='/ru/${StaticLandingRoutes.capabilitiesMailing.path}'>E-mail рассылка</a>`,
        value: 5,
        isHtml: true,
    },
    {
        label: `<a href='/ru/${StaticLandingRoutes.capabilitiesApi.path}'>API</a>`,
        value: 6,
        isHtml: true,
    },
    {
        label: `<a href='/ru/${StaticLandingRoutes.functions.path}'>Функционал</a>`,
        value: 7,
        isHtml: true,
    },
];
